import { useState } from 'react';

import { toast } from 'react-toastify';

import PrimaryButton from '../../../components/UI/Buttons/PrimaryButton';
import Modal from '../../../components/UI/Modals/Modal';
import { client } from '../../../networking/client';
import classes from './PayInvoiceModal.module.css';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  productId: number;
  customerEmail: string;
  resetCustomerAndProduct: () => void;
};

const PayInvoiceModal: React.FC<Props> = ({
  isOpen,
  onClose,
  productId,
  customerEmail,
  resetCustomerAndProduct,
}) => {
  const [searchInvoice, setSearchInvoice] = useState<string>('');
  const { translations } = useTranslation();
  const onConfirmInvoiceHandler = async () => {
    try {
      await client.post('/healthpoint/confirm-hellocash-payment', {
        invoiceId: parseInt(searchInvoice.trim()),
        productId: parseInt(productId.toString()),
        customerEmail: customerEmail,
      });
      resetCustomerAndProduct();
      toast.success(translations('invoice.confirmed'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setSearchInvoice('');
      onClose();
    } catch (err: any) {
      toast.error(err?.response?.data?.error ?? translations('failed.to.confirm'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} containerPadding="10px" width="40%">
      <div className={classes.container}>
        <div className={classes.header}>
          <div className={classes.title}>{translations('enter.invoice.id')}</div>
        </div>
        <div className={classes.content}>
          <div className={classes.searchInvoice}>{translations('invoice.id')}</div>
          <input
            className={classes.searchInput}
            value={searchInvoice}
            onChange={(e) => setSearchInvoice(e?.target?.value)}
          />
        </div>
        <div className={classes.button}>
          <PrimaryButton
            onClick={() => {
              setSearchInvoice('');
              onClose();
            }}
            text={translations('button.cancel')}
            disabled={false}
            invertedColors={true}
            containerStyle={{ marginTop: '2px', marginBottom: '30px' }}
          />
          <div style={{ width: '50px' }}></div>
          <PrimaryButton
            onClick={onConfirmInvoiceHandler}
            text={translations('button.save')}
            disabled={false}
            containerStyle={{ marginTop: '2px', marginBottom: '30px' }}
          />
        </div>
      </div>
    </Modal>
  );
};
export default PayInvoiceModal;
